import frAuth from "./frAuth";
import frEntities from "./frEntities";

export default {
  ...frAuth,
  ...frEntities,
  common: {
    yes: "Oui",
    no: "Non",
    closePanel: "Fermer le volet",
    resizePanel: "Redimensionner le volet",
    copyMarkdown: "Copier le contenu en Markdown",
    copyMarkdownDone: "Contenu copié",
    downloadMarkdown: "Télécharger en Markdown",
  },
  menu: {
    title: "PM Admin",
    topics: "Thèmes",
    categories: "Catégories",
    images: "Images",
    testimonies: "Témoignages",
    trainingVersions: "Versions de formation",
    darkMode: "Thème",
    editMode: "Mode édition",
    signOut: "Déconnexion",
  },
  form: {
    delete: "Supprimer",
    cancel: "Annuler",
    update: "Mettre à jour",
    create: "Créer",
    back: "Retour",
    edit: "Modifier",
    add: "Ajouter",
    preview: "Prévisualisation",
    none: "Aucun",
    help: "Informations",
    reorder: "Réorganiser",
    moveItemUp: "Déplacer vers le haut",
    moveItemDown: "Déplacer vers le bas",
    validate: "Valider",
    emptyList: "Aucun élément",
    noResults: "Aucun résultat",
    removeTag: "Retirer",
    validationErrors: "Il y a des erreurs dans le formulaire",
  },
  error: {
    noDataMessage: "Aucune donnée",
  },
  modal: {
    deleteTitle: "Supprimer un élément",
    deleteMessage: "Êtes-vous sûr de vouloir supprimer cet élément ?",
    unsavedTitle: "Modifications non enregistrées",
    unsavedMessage:
      "Vous avez des changements non sauvegardés. Fermer quand même ?",
  },
  search: "Rechercher",
  action: {
    error: "Une erreur est survenue",
    createdSuccess: "Création avec succès",
    createdError: "Une erreur est survenue lors de la création",
    deleteSuccess: "Suppression avec succès",
    deleteError: "Une erreur est survenue lors de la suppression",
    updateSuccess: "Mise à jour avec succès",
    updateError: "Une erreur est survenue lors de la mise à jour",
  },
  history: {
    title: "Historique",
    tab: {
      versions: "Versions",
      deleted: "Éléments supprimés",
    },
    empty: "Aucun historique pour le moment",
    emptyHint:
      "Les créations, modifications et suppressions de cet élément s'afficheront ici, avec leur auteur.",
    loadError: "Impossible de charger l'historique",
    unknownAuthor: "Auteur non identifié",
    emptyValue: "vide",
    // Un id de relation est toujours accompagné du nom de l'élément qu'il désigne.
    unknownRecord: "élément introuvable",
    deletedRecord: "supprimé",
    today: "Aujourd'hui",
    yesterday: "Hier",
    action: {
      create: "Création",
      update: "Modification",
      delete: "Suppression",
      restore: "Restauration",
      reorder: "Déplacement",
    },
    // Résumé de repli quand aucun champ n'a changé de valeur.
    summary: {
      create: "Contenu initial",
      update: "Aucun champ modifié",
      delete: "Élément supprimé",
      restore: "État restauré",
      reorder: "Position modifiée",
    },
    // Phrase de contexte au-dessus du détail.
    detail: {
      change: "Modifié par {{author}} le {{date}}",
      create: "Contenu à la création, par {{author}} le {{date}}",
      delete: "Contenu au moment de la suppression, par {{author}} le {{date}}",
      restore: "Contenu recréé par {{author}} le {{date}}",
    },
    collection: {
      topics: "Thème",
      topicParts: "Partie",
      topicPartQuestions: "Question",
      testimonies: "Témoignage",
      trainingVersions: "Version de formation",
    },
    // Libellés des champs techniques, absents des formulaires.
    field: {
      trainingId: "Formation",
      topicId: "Thème",
      topicPartId: "Partie",
      introduction: "Introduction",
      relatedTestimonyIds: "Témoignages liés",
      timing: "Durée",
      categoryId: "Catégorie",
    },
    compareCurrentToggle: "Comparer à l'état actuel",
    compareWithThis: "Comparer avec cette version ({{date}})",
    clearComparison: "Revenir à la comparaison par défaut",
    currentState: "L'état actuel",
    noDifference: "Aucun écart entre ces deux états",
    markupOnly: "mise en forme uniquement",
    showReorders: "Afficher les déplacements ({{count}})",
    hideReorders: "Masquer les déplacements",
    restore: "Restaurer",
    restoreThisState: "Restaurer cet état",
    restoreVersionOf: "Restaurer l'état du {{date}}",
    confirmRestoreTitle: "Restaurer cet état",
    confirmRestoreMessage:
      "Le contenu actuel sera remplacé par celui de la version sélectionnée. L'opération est enregistrée dans l'historique : vous pourrez revenir en arrière.",
    confirmRestoreDeletedTitle: "Restaurer cet élément",
    confirmRestoreDeletedMessage:
      "Recréer « {{label}} » à partir de son dernier état connu ?",
    confirmRestoreDeletedWithChildrenMessage:
      "Recréer « {{label}} » à partir de son dernier état connu ? Les {{count}} éléments supprimés avec lui seront également restaurés.",
    restoreSuccess: "État restauré",
    restoreSuccessWithChildren:
      "Élément restauré, ainsi que {{count}} élément(s) lié(s)",
    restoreError: "La restauration a échoué",
    restoreNotRecovered:
      "Certains contenus n'ont pas pu être récupérés : {{fields}}. Ils n'existent plus.",
    restoreChildrenFailed:
      "{{count}} élément(s) lié(s) n'ont pas pu être restaurés.",
    error: {
      parentMissing:
        "L'élément parent n'existe plus : restaurez-le d'abord pour pouvoir restaurer celui-ci.",
      forbidden: "Vous n'avez pas les droits nécessaires pour cette restauration.",
      trainingNotResolved:
        "Impossible de rattacher cet élément à une formation : son parent a probablement été supprimé. Restaurez d'abord le parent.",
      invalidSnapshot: "Cette version est illisible et ne peut pas être restaurée.",
      accountDisabled: "Votre compte a été désactivé.",
    },
    noDeletedItems: "Aucun élément supprimé",
    noDeletedItemsHint:
      "Les parties et questions supprimées apparaîtront ici, avec la possibilité de les restaurer.",
    deletedOn: "supprimé le {{date}}",
    lastSeenOn: "dernière trace le {{date}}",
    restored: "Restauré",
    restoredOn: "restauré le {{date}} par {{author}}",
    restoredWithParent: "revient avec son parent",
    limitations:
      "Un élément créé puis supprimé avant l'activation de l'historique peut n'en garder aucune trace, et les images supprimées ne sont pas récupérables.",
  },
  validation: {
    required: "Ce champ est requis",
    url: "Cet url est invalide",
    integer: "Cette valeur doit contenir uniquement des chiffres",
    requiredMin: "Ce champ doit contenir au moins {{count}} caractères",
    requiredMax: "Ce champ doit contenir maximum {{count}} caractères",
    arrayRequired: "Au moins un élément est requis",
    arrayMin: "Au moins {{count}} éléments sont requis",
    imageValidation: "Une image est requise",
    noNewLines: "Ce champ ne doit pas contenir de nouvelles lignes",
  },
};
